import { TenantUserRow } from "services/api/tenants/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const TENANT_USERS_COLUMNS = (
  handlePasswordClick: (event: React.MouseEvent<HTMLSpanElement>, id: string) => void,
  handleImpersonateClick: (event: React.MouseEvent<HTMLSpanElement>, id: string) => void
): Column[] => [
  {
    title: "Korisnik",
    field: "firstName",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <UserCell
        fullName={[row.firstName, row.lastName].filter(Boolean).join(" ")}
        userId={row.id}
        email={row.email}
      />
    ),
  },
  {
    title: "Email",
    field: "email",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <span className="text-sm text-slate-900">{row.email}</span>
    ),
  },
  {
    title: "Uloge",
    field: "roles",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) =>
      row.roles?.length > 0 ? (
        <span className="text-sm text-slate-500">
          {row.roles.map((role) => role.name).join(", ")}
        </span>
      ) : (
        <span className="text-sm text-slate-400">Bez uloge</span>
      ),
  },
  {
    title: "",
    key: "user_actions",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <ButtonMenu
        endIcon="/media/icons/more-dots.svg"
        cssClassName="h-full"
        variant="text"
      >
        <ButtonMenuItem
          startIcon="/media/icons/user-edit.svg"
          onClick={(e) => handleImpersonateClick(e, row.id)}
        >
          Prijavi se kao
        </ButtonMenuItem>

        <ButtonMenuItem
          startIcon="/media/icons/user-edit.svg"
          onClick={(e) => handlePasswordClick(e, row.id)}
        >
          Promijeni lozinku
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
